import React, { Component } from 'react';
import ProgressBar from "./components/header/ProgressBar";
import StepCategories from "./components/Step_1/StepCategories";
import StepOffices from "./components/Step_2/StepOffices";
import StepTime from "./components/Step_3/StepTime";
import StepPersonalData from "./components/Step_4/StepPersonalData";
import StepConfirmation from "./components/Step_5/StepConfirmation";
import AppNavigation from "./components/AppNavigation";
import ResultConfirmPage from "./components/resultConfirmPage/ResultConfirmPage";
import './App.css';
import GlobalStore from "./store/GlobalStore";
import ReactQueryParams from 'react-query-params';
// import staticElementObject from "./staticElementObject";
import { config } from './config.js';

class App extends ReactQueryParams {
    constructor(props) {
        super(props);
        GlobalStore.getInstance().initialize(); //це важливо для того щоб зчитати дані з кук коли запускається апка
        if (GlobalStore.getInstance().data['currentStep']) {
            this.state = { step : GlobalStore.getInstance().data['currentStep'] };
        } else {
            this.state = { step: 1 }
        }

        this.nextStep = this.nextStep.bind(this);
        this.previousStep = this.previousStep.bind(this);
    }

    componentDidMount() {
        console.log(process.env.REACT_APP_STAGE);
        if (this.queryParams.env === "test" || process.env.REACT_APP_STAGE === "dev") {
            alert("test detected! а це значить шо поки ти бачиш цей алєрт, можеш робити скікозавгодно бронювань - в аналітиці вони не врахуються");
        }
        if (this.queryParams.env !== "test") {
            console.log("всьо ок, енв не дорівнює тест");
        }
        console.log("config environment: " + config.environment);
        console.log(process.env.REACT_APP_VERSION);
    }

    nextStep() {
        this.setState({
            step : this.state.step + 1
        }, () => {
            // console.log(this.state.step);
            GlobalStore.getInstance().data['currentStep'] = this.state.step;
        });
        window.scrollTo(0, 0);
    }

    previousStep() {
        this.setState({
            step : this.state.step - 1
        }, () => {
            GlobalStore.getInstance().data['currentStep'] = this.state.step;
        });
        window.scrollTo(0, 0);
    }

    showStep() {
        switch (this.state.step) {
            case 1:
                return (
                    <div>
                        <AppNavigation stepNumber="1" stepName="Valitse erikoisala" backNavigation={false} />
                        <StepCategories nextStep={this.nextStep} />
                    </div>
                );
            case 2:
                return (
                    <div>
                        <AppNavigation stepNumber="2" stepName="Valitse toimipiste" previousStep={this.previousStep} />
                        <StepOffices nextStep={this.nextStep} previousStep={this.previousStep} />
                    </div>
                );
            case 3:
                return (
                    <div>
                        <AppNavigation stepNumber="3" stepName="Valitse henkilö" previousStep={this.previousStep} />
                        <StepTime nextStep={this.nextStep} previousStep={this.previousStep} />
                    </div>
                );
            case 4:
                return (
                    <div>
                        <AppNavigation stepNumber="4" stepName="Täytä henkilötiedot" previousStep={this.previousStep} />
                        <StepPersonalData nextStep={this.nextStep} previousStep={this.previousStep} />
                    </div>
                );
            case 5:
                return (
                    <div>
                        <AppNavigation stepNumber="5" stepName="Vahvista ajanvaraus" previousStep={this.previousStep} />
                        <StepConfirmation previousStep={this.previousStep} nextStep={this.nextStep} />
                    </div>
                );
            case 6:
                return (
                    <ResultConfirmPage/>
                );
        }
    }

    render() {
        // GlobalStore.getInstance().data['currentStep'] = 1;
        // GlobalStore.getInstance().data['filterDoctorName'] = undefined;
        // GlobalStore.getInstance().data['filterDoctorId'] = undefined;
        return (
        <div className="App">
            {(this.state.step !== 6) ? <div className="wrapperContainer"><div className="ProgressBarRelativeContainer"><ProgressBar currentStep={this.state.step} /></div><div className="appBody container-fluid">{this.showStep()}</div></div> : <div className="wrapperFullWidth">{this.showStep()}</div>}
        </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js